import React, { Fragment } from 'react';
import { Form, Input, DatePicker } from 'antd';
import {
  dateFormat,
  start_date,
} from '../../../../../../common/utils/configFormField';
import locale from 'antd/lib/date-picker/locale/ru_RU';

const ContractOsgopp = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Договор ОСГОПП:</span>
      <Form.Item>
        {getFieldDecorator('contractOsgoppNum')(
          <Input
            maxLength={20}
            placeholder="Укажите серию и номер договора ОСГОПП"
            disabled={disabled}
          />
        )}
      </Form.Item>
      <div className="dogovorOcgoppArea">
        <span className="label">Действителен до:</span>
        <Form.Item>
          {getFieldDecorator('contractOsgoppValidUntilDate')(
            <DatePicker
              placeholder="ДД.ММ.ГГГГ"
              format={dateFormat}
              disabledDate={start_date}
              className="basicInput"
              disabled={disabled}
              locale={locale}
            />
          )}
        </Form.Item>
      </div>
    </Fragment>
  );
};

export default ContractOsgopp;
